<template>
  <BaseGridView
    endpoint="v1/Customer/GetData"
    :pageTitle="$t('Customers')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
    :templateDef="templateDef"
  >
    <template #customer_isActive="{ rowData }">
      <span
        :class="rowData.value ? 'badge text-bg-success' : 'badge text-bg-danger'"
      >
        {{ rowData.value ? "Active" : "Inactive" }}
      </span>
    </template>
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";

let columnDef = ref([] as ColumnModel[]);
const templateDef: TemplateDef = {
  prefix: "customer",
  columnNames: ["isActive"],
};
const _searchOptions = {
  fields: [
    "company.Name",
    "name",
    "legalName",
    "contactCreatedDateTimeOffset",
    "customerCreatedDateTimeOffset",
    "customerSince",
    "emailAddress",
    "invoiceEmailAddress",
    "lastChangedDateTimeOffset",
    "phoneNumber",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
      freeze: "Left",
      width: 200,
    },
    { field: "name", headerText: instance?.$t("name") },
    { field: "legalName", headerText: instance?.$t("legalName") },
    {
      field: "contactCreatedDateTimeOffset",
      headerText: instance?.$t("contactCreatedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    {
      field: "customerCreatedDateTimeOffset",
      headerText: instance?.$t("customerCreatedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "customerSince", headerText: instance?.$t("customerSince") },
    { field: "emailAddress", headerText: instance?.$t("emailAddress") },
    {
      field: "invoiceEmailAddress",
      headerText: instance?.$t("invoiceEmailAddress"),
    },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "customer_isActive",
    },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "phoneNumber", headerText: instance?.$t("phoneNumber") },
  ];
};
</script>
